import { render, staticRenderFns } from "./StoriesArticleAudio.vue?vue&type=template&id=3db2e246&scoped=true&"
import script from "./StoriesArticleAudio.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleAudio.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleAudio.vue?vue&type=style&index=0&id=3db2e246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db2e246",
  null
  
)

export default component.exports